module.exports = __webpack_public_path__ + "static/media/au-aid-logo.fc766440.svg";